import { sortBy } from 'lodash';
import { ReactNode } from 'react';

import { api } from '../../../../api';
import HubPageLayout from '../../../../common/hub/HubPageLayout';
import { formatError } from '../../../../util/errors';
import { AddAStudentCard, StudentCard, StudentCardSkeleton } from '../../home/widgets/SnapshotWidget/student-card';

// Full-page list of the account's students. Reuses the cards from the home
// SnapshotWidget, but renders every student in a responsive grid (no carousel)
// followed by the "Add a student" card.
export const StudentsPage = () => {
  const {
    data: students,
    isLoading: isStudentsLoading,
    error: studentsError,
  } = api.student.all.useQuery(undefined, {
    select: (data) => sortBy(data, ['firstName', 'lastName']),
  });

  let content: ReactNode;

  if (studentsError) {
    content = (
      <div className="flex w-full flex-col gap-2 py-2">
        <div className="flex items-center justify-center">Something went wrong 😭</div>
        <pre className="text-center text-xs">{formatError(studentsError)}</pre>
      </div>
    );
  } else if (isStudentsLoading) {
    content = (
      <div className="grid gap-[30px] md:grid-cols-2 md:gap-4 lg:grid-cols-3">
        <StudentCardSkeleton />
        <StudentCardSkeleton />
        <StudentCardSkeleton />
      </div>
    );
  } else {
    content = (
      <div className="grid gap-[30px] md:grid-cols-2 md:gap-4 lg:grid-cols-3">
        {students?.map((student) => (
          <StudentCard key={student.studentId} student={student} className="w-full md:w-auto" />
        ))}
        <AddAStudentCard className="w-full md:w-auto" />
      </div>
    );
  }

  return <HubPageLayout title="Students">{content}</HubPageLayout>;
};
